import mutations from './mutations';
import actions from './actions';
import getters from './getters';

const initialState = {
  queueList: [],
  socket: {
    connected: false,
  },
  filtered: false,
  isQueueOpened: false,
  loadingQueueAction: false,
};

const calendarModule = {
  namespaced: true,

  state: initialState,
  mutations,
  actions,
  getters,
};

export default calendarModule;
